// extracted by mini-css-extract-plugin
export default {"add_wrap":"seasonalTheme_add_wrap__Fxj42","add_btn":"seasonalTheme_add_btn__OxckU","number_badge_wrap":"seasonalTheme_number_badge_wrap__vHHqD","badge":"seasonalTheme_badge__uEfp2"};